"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SvgIcon = (0, _createSvgIcon["default"])([/*#__PURE__*/React.createElement("mask", {
  id: "mask0_1418_9",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "2",
  width: "13",
  height: "13",
  key: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.7377 2.433c.4532-.5415 1.6873-.6121 2.0397.0002l3.7296 6.3396c.3524.6123-.0043 1.3871-.6983 1.5101l-7.5324 1.4833-2.4908-4.328L7.7377 2.433ZM2.0665 7.8547l2.4907 4.3279-.5585.3235c-.4857.2813-1.1068.1144-1.3873-.3729L1.1362 9.5699c-.2804-.4873-.114-1.1104.3717-1.3917l.5586-.3235Zm3.6249 4.6328.0236-.0137 2.5814-.4574.7048 1.2247c.2804.4873.114 1.1103-.3717 1.3917l-.3981.2305c-.4857.2814-1.1068.1144-1.3873-.3729l-1.1527-2.0029Z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1418_9)",
  key: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}))], 'IconNotificationIcon', '1em', '1em', '', '0 0 16 16');
SvgIcon.displayName = 'IconNotification';
var _default = SvgIcon;
exports["default"] = _default;